var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { initialState as userState } from '../../store/userImportNew/reducer';
import { makeSelectApps } from '../Root/selectors';
/**
 * Direct selector to the groups state domain
 */
var selectGroupsDomain = function (state) { return state.groups || initialState; };
var selectGroups = function (state) { return (state.groups && state.groups.groups) || []; };
var selectUserNewDomain = function (state) { return state.userNew || userState; };
/**
 * Other specific selectors
 */
var selectedGroups = createSelector(selectGroups, makeSelectApps(), function (groups, apps) {
    return groups.map(function (group) {
        var split = group.id.split(':');
        var app = apps === null || apps === void 0 ? void 0 : apps.find(function (a) { return a.id === split[1]; });
        return __assign(__assign({}, group), { appName: (app && app.name) || group.app });
    });
});
/**
 * Default selector used by Groups
 */
export var selectUser = createSelector(selectUserNewDomain, function (substate) { return substate; });
export default (function (state) {
    var groupsDomain = selectGroupsDomain(state);
    return __assign(__assign({}, groupsDomain), { groups: selectedGroups(state) });
});
